import React, { Fragment } from 'react'
import { StatusApprovalCheckbox } from './status-approval-checkbox'
import { I18nConsumer } from '../i18n-provider'
import { MultiSelectCombobox } from '../../legacy-design-system/combobox/multi-select-combobox'
import { Severity } from '../vulnerability-severity'
import { defaultStatusRegistry } from '../vulnerability-status'
import { css } from '@emotion/css'

interface ApprovalWorkflowSettingsProps {
  readonly enabled: boolean
  readonly statuses: string[]
  readonly severities: Severity[]
  readonly onEnabling: (enabled: boolean) => void
  readonly onStatusChange: (statuses: string[]) => void
  readonly onSeveritiesChange: (enabled: Severity[]) => void
}

export const vulnerabilityBehaviorTitle = css`
  display: inline-block;
  margin-bottom: 10px;
  font-size: 17px;
`

export function ApprovalWorkflowSettingsForm({
  enabled,
  statuses,
  severities,
  onEnabling,
  onStatusChange,
  onSeveritiesChange
}: ApprovalWorkflowSettingsProps) {
  const allClosedStatusNames = defaultStatusRegistry.closed.map(
    (status) => status.name
  )
  return (
    <I18nConsumer>
      {({ intl }) => (
        <div>
          <strong className={vulnerabilityBehaviorTitle}>
            {intl.formatMessage({
              id: 'title_approvalWorkflow'
            })}
          </strong>
          <StatusApprovalCheckbox
            label={intl.formatMessage({
              id: 'detail_enableStatusApprovalWorkflow_checkbox'
            })}
            value={enabled}
            onChange={onEnabling}
          />
          {enabled && (
            <Fragment>
              <MultiSelectCombobox<string>
                label={intl.formatMessage({ id: 'title_status' })}
                id="status_approval_workflow_statuses"
                renderLabel={() => undefined}
                items={[
                  {
                    items: allClosedStatusNames
                  }
                ]}
                onChange={onStatusChange}
                values={statuses}
                placeHolderTag={intl.formatMessage({
                  id: 'title_allStatuses'
                })}
                itemToString={(status) =>
                  intl.formatMessage({
                    id: defaultStatusRegistry.fromName(status).i18nID
                  })
                }
                itemToID={(status) => `status-${status}`}
              />
              <div
                className={css`
                  margin: 4px 0 16px 0;
                `}
              >
                <MultiSelectCombobox<Severity>
                  label={intl.formatMessage({
                    id: 'title_severityLevel'
                  })}
                  id="status_approval_workflow_severities"
                  renderLabel={() => undefined}
                  items={[
                    {
                      items: Severity.all
                    }
                  ]}
                  itemToString={(severity) =>
                    intl.formatMessage({
                      id: severity.i18nID
                    })
                  }
                  onChange={onSeveritiesChange}
                  values={severities}
                  placeHolderTag={intl.formatMessage({
                    id: 'title_allSeverities'
                  })}
                  itemToID={(severity) => `severity-${severity.name}`}
                />
              </div>
            </Fragment>
          )}
        </div>
      )}
    </I18nConsumer>
  )
}
